<script>
  import LegendItem from "../../primitives/LegendItem.svelte"
</script>

<div class="legend">
  <!--LegendItem class="col" iconClasses="fa-duotone fa-solid fa-ticket" iconColor="#ff720d">
    <p>Ticket Received</p>
  </LegendItem-->
  <LegendItem class="col" iconClasses="fa-duotone fa-solid fa-eye" iconColor="#0800ff" additionalStyles="border-radius: 50%; padding: 0.1em;">
    <p>Pending</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-duotone fa-solid fa-thumbs-up" iconColor="#008328">
    <p>Approved</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-duotone fa-solid fa-thumbs-down" iconColor="#e00122">
    <p>Denied</p>
  </LegendItem>
  <LegendItem class="col" iconClasses="fa-duotone fa-solid fa-triangle-exclamation" iconColor="#ff720d">
    <p>Exception</p>
  </LegendItem>
</div>

<style>
  .legend {
    display: flex;
    font-weight: 600;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 1.5em 0;
    justify-content: flex-end;
    background-color: #FFF;
    border-radius: 1rem;
  }
  @media(max-width: 850px) {
    .legend {
      
    }
  }
</style>